module.exports = __webpack_public_path__ + "img/map.0b86311e.png";